define.alias("ember-math-helpers/helpers/mult", "calendar/helpers/mult");